module.exports = __webpack_public_path__ + "img/btn.b2cb4ea7.png";